(() => {
  // People holding a code, and everyone during Black Friday (26 to 30 Nov 2026 SAST), don't need the 10% popup.
  if (/(^|;\s*)discount_code=/.test(document.cookie) || (Date.now() >= Date.UTC(2026,10,25,22,0) && Date.now() < Date.UTC(2026,10,30,22,0))) document.head.append(Object.assign(document.createElement('style'), {textContent: 'shopify-forms-embed{display:none!important}'}));
  function bindNavigation(scope = document) {
    const hoverPointer = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)');
    scope.querySelectorAll('.cm-nav-group').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      const summary = group.querySelector('summary');
      let closeTimer;
      const desktop = () => hoverPointer.matches && !!group.closest('.chepa-desktop-nav');
      const open = () => {
        clearTimeout(closeTimer);
        group.parentElement.querySelectorAll('.cm-nav-group[open]').forEach(other => { if (other !== group) other.open = false; });
        group.open = true;
      };
      group.addEventListener('pointerenter', event => { if (desktop() && event.pointerType !== 'touch') open(); });
      group.addEventListener('pointerleave', () => {
        if (desktop()) closeTimer = setTimeout(() => { if (!group.querySelector(':focus-visible')) group.open = false; }, 180);
      });
      summary.addEventListener('click', event => {
        if (desktop() && event.detail > 0) { event.preventDefault(); open(); }
      });
      group.addEventListener('focusout', event => {
        if (event.relatedTarget && !group.contains(event.relatedTarget)) { clearTimeout(closeTimer); group.open = false; }
      });
      group.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); clearTimeout(closeTimer); summary.focus(); group.open = false; }
        if (event.key === 'ArrowDown' && event.target === summary) {
          event.preventDefault(); open(); group.querySelector('.cm-nav-submenu a')?.focus();
        }
      });
    });
  }
  bindNavigation();
  document.addEventListener('shopify:section:load', event => bindNavigation(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.cm-nav-group[open]').forEach(group => { if (!group.contains(event.target)) group.open = false; });
  });
  const strings = window.chepaStrings || {};
  const root = window.Shopify?.routes?.root || '/';
  let bagBusy = false;
  let bagRequest = 0;
  let bagTrigger;
  const bag = () => document.getElementById('ChepaBag');
  function showBag() {
    if (!bag()) return;
    bagTrigger = document.activeElement;
    if (!bag().open) bag().showModal();
    document.body.classList.add('chepa-modal-open');
  }
  function bindBag() {
    bag()?.addEventListener('close', () => {
      document.body.classList.remove('chepa-modal-open');
      if (bagTrigger?.isConnected) bagTrigger.focus();
    });
  }
  function replaceBag(html, open, focusKey) {
    const next = new DOMParser().parseFromString(html, 'text/html').getElementById('ChepaBag');
    if (!next || !bag()) throw new Error(strings.cart_error);
    const wasOpen = bag().open;
    if (wasOpen) bag().close();
    bag().replaceWith(next);
    bindBag();
    document.querySelectorAll('[data-chepa-cart-count]').forEach(el => { el.textContent = `(${next.dataset.count})`; });
    if (open || wasOpen) {
      next.showModal();
      document.body.classList.add('chepa-modal-open');
      if (focusKey) {
        const input = Array.from(next.querySelectorAll('[data-chepa-quantity]')).find(el => el.dataset.key === focusKey);
        (input || next.querySelector('[name="checkout"]') || next.querySelector('[data-chepa-close]')).focus();
      }
    }
  }
  function error(message) {
    const target = bag()?.querySelector('[data-chepa-bag-error]');
    if (target) target.textContent = message ?? strings.cart_error;
    const fallback = bag()?.querySelector('[data-chepa-error-link]');
    if (fallback) fallback.hidden = !message;
  }
  async function refreshBag(open = false) {
    if (bagBusy) return;
    const request = ++bagRequest;
    if (open) showBag();
    try {
      const url = `${root}?sections=chepa-bag`;
      const response = await fetch(url, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(strings.cart_error);
      const data = await response.json();
      if (request === bagRequest) replaceBag(data['chepa-bag'], open);
    } catch { error(strings.cart_error); }
  }
  async function changeQuantity(key, quantity) {
    if (bagBusy || !Number.isInteger(quantity) || quantity < 0) return;
    bagBusy = true;
    ++bagRequest;
    bag().querySelectorAll('input,button').forEach(el => { if (!el.hasAttribute('data-chepa-close')) el.disabled = true; });
    bag().setAttribute('aria-busy', 'true');
    error('');
    try {
      const response = await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['chepa-bag'],sections_url:root})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.cart_error);
      replaceBag(data.sections['chepa-bag'], true, key);
    } catch (e) { error(e.message); }
    finally {
      bagBusy = false;
      bag()?.removeAttribute('aria-busy');
      bag()?.querySelectorAll('input,button').forEach(el => { el.disabled = false; });
    }
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-chepa-open-bag]');
    const close = event.target.closest('[data-chepa-close]');
    const remove = event.target.closest('[data-chepa-remove]');
    if (open && bag()) { event.preventDefault(); refreshBag(true); }
    if (close) close.closest('dialog')?.close();
    if (remove) changeQuantity(remove.dataset.key, 0);
    if (event.target === bag()) {
      const rect = bag().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) bag().close();
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-chepa-quantity]')) {
      const number = Number(event.target.value);
      if (!Number.isInteger(number) || number < 0) { error(strings.quantity_error); return; }
      changeQuantity(event.target.dataset.key, number);
    }
  });
  document.addEventListener('theme:cartchanged', event => {
    const open = !document.body.classList.contains('template-cart') || Boolean(bag()?.open);
    if (event.detail?.sections?.['chepa-bag']) {
      ++bagRequest;
      replaceBag(event.detail.sections['chepa-bag'], open);
    } else refreshBag(open);
  });
  bindBag();
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let motion = !reduce.matches;
  function setMotion(enabled) {
    motion = enabled;
    document.documentElement.classList.toggle('chepa-motion-off', !enabled);
  }
  reduce.addEventListener('change', e => setMotion(!e.matches));
  setMotion(motion);
  if ('IntersectionObserver' in window && motion) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.remove('cm-waiting');observer.unobserve(entry.target);}}),{threshold:.08});
    document.querySelectorAll('.cm-category,.cm-feature-copy,.cm-feature-image').forEach(el => {if(el.getBoundingClientRect().top>innerHeight){el.classList.add('cm-reveal','cm-waiting');observer.observe(el);}});
  }
  const sticky = document.querySelector('[data-chepa-sticky]');
  const main = document.querySelector('.section-main-product');
  // Keep app launchers clear of the mobile purchase area, including late app loads.
  if (main && 'IntersectionObserver' in window) {
    const purchaseArea = main.querySelector('.detail');
    if (purchaseArea) new IntersectionObserver(entries => {
      document.body.classList.toggle('cm-purchase-in-view', entries[0].isIntersecting);
    }, {rootMargin: '80px 0px'}).observe(purchaseArea);
  }
  if (sticky && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--cm-buy-height', `${sticky.getBoundingClientRect().height}px`);
    }).observe(sticky);
  }
  function bindDiscountTeasers() {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const embed = host.shadowRoot?.querySelector('[data-form-root]');
      if (!embed || host.dataset.chepaTeaserBound) return;
      host.dataset.chepaTeaserBound = 'true';
      const sync = () => host.classList.toggle('cm-discount-teaser', embed.dataset.currentStep === 'tease');
      sync();
      new MutationObserver(sync).observe(embed, {attributes:true, attributeFilter:['data-current-step']});
      // On phones the popup's transparent layer covers the page; a tap outside the card closes it.
      host.shadowRoot.addEventListener('click', event => {
        if (event.target.matches?.('[role="dialog"]:not([data-sizing])')) host.shadowRoot.querySelector('[aria-label="Close modal"]')?.click();
      });
    });
  }
  // Shopify Forms can attach its shadow DOM after the host is inserted.
  let teaserAttempts = 0;
  const teaserTimer = setInterval(() => {
    bindDiscountTeasers();
    if (++teaserAttempts >= 90 || document.querySelector('[data-chepa-teaser-bound]')) clearInterval(teaserTimer);
  }, 1000);
  if (sticky && main) {
    const form = main.querySelector('form.product-purchase-form');
    const button = form?.querySelector('button[type="submit"]');
    const stickyButton = sticky.querySelector('button');
    function syncSticky() {
      if (!button) return;
      stickyButton.textContent = button.textContent;
      stickyButton.disabled = button.disabled;
      const price = (document.documentElement.classList.contains('cm-bf-on') && main.querySelector('.price-container .cm-bf-new')) || main.querySelector('.price-container .current-price');
      if (price) sticky.querySelector('[data-chepa-sticky-price]').textContent = price.textContent;
    }
    if (button) {
      syncSticky();
      new MutationObserver(syncSticky).observe(form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
      const priceArea = main.querySelector('.price-container');
      if (priceArea) new MutationObserver(syncSticky).observe(priceArea,{subtree:true,childList:true,characterData:true});
      stickyButton.addEventListener('click', () => {
        if (!form.querySelector('[name="id"]')?.value) {
          const picker=main.querySelector('.option-selectors');
          picker?.scrollIntoView({behavior:motion?'smooth':'auto',block:'center'});
          picker?.querySelector('input,button')?.focus({preventScroll:true});
          return;
        }
        form.requestSubmit(button);
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;},{threshold:0}).observe(button);
    } else sticky.hidden=true;
  }
})();
